import type { EmptyProps } from 'antd';
import { Empty } from 'antd';
import React from 'react';

const FBEmpty: React.FC<EmptyProps> & {
  PRESENTED_IMAGE_SIMPLE: typeof Empty.PRESENTED_IMAGE_SIMPLE;
  PRESENTED_IMAGE_DEFAULT: typeof Empty.PRESENTED_IMAGE_DEFAULT;
} = ({ ...rest }) => <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} {...rest} />;

FBEmpty.PRESENTED_IMAGE_SIMPLE = Empty.PRESENTED_IMAGE_SIMPLE;
FBEmpty.PRESENTED_IMAGE_DEFAULT = Empty.PRESENTED_IMAGE_DEFAULT;

export default FBEmpty;
